
import { z } from "zod";

export const ExtendedScheduleReasonValues = ["CREW_AT_FULL_CAPACITY", "HOMEOWNER_PREFERENCE", "NOT_EXTENDED_SCHEDULING", "OTHER", "PENDING_HOA", "SCHEDULING_AROUND_RELATED_PROJECT", "WEATHER"] as const;
export const ExtendedScheduleReasonSchema = /* @__PURE__ */ z.enum(ExtendedScheduleReasonValues);
export const ExtendedScheduleReason: (typeof ExtendedScheduleReasonSchema)["enum"] = { "CREW_AT_FULL_CAPACITY": "CREW_AT_FULL_CAPACITY", "HOMEOWNER_PREFERENCE": "HOMEOWNER_PREFERENCE", "NOT_EXTENDED_SCHEDULING": "NOT_EXTENDED_SCHEDULING", "OTHER": "OTHER", "PENDING_HOA": "PENDING_HOA", "SCHEDULING_AROUND_RELATED_PROJECT": "SCHEDULING_AROUND_RELATED_PROJECT", "WEATHER": "WEATHER" };
export type ExtendedScheduleReason = (typeof ExtendedScheduleReasonValues)[number];
export const ExtendedScheduleReasonDisplayNames = { "CREW_AT_FULL_CAPACITY": "Crew at full capacity",
"HOMEOWNER_PREFERENCE": "Homeowner preference",
"NOT_EXTENDED_SCHEDULING": "Not extended scheduling",
"OTHER": "Other",
"PENDING_HOA": "Pending HOA",
"SCHEDULING_AROUND_RELATED_PROJECT": "Scheduling around related project",
"WEATHER": "Weather", } satisfies Record<ExtendedScheduleReason, string>;
